import {OtherDocumentClause} from "common/types/clause_preview";

export default function clausePreviewKey(clause: OtherDocumentClause): string {
  return [
    clause.document_id,
    clause.section_reference ?? "",
    clause.clause_reference ?? "",
  ].join(":");
}
